import { IApplicationState } from '../types/redux';

export const buildersSelector = (state: IApplicationState) => {
  return state.newbuilding.builders;
};

export function buildersWithPhonesSelector(state: IApplicationState) {
  const {
    newbuilding: { builders },
  } = state;

  if (builders) {
    return builders.filter(builder => builder.showPhone && builder.phone);
  }

  return [];
}
